import { IFormCategories } from 'legacy/lut/classes/models/IFormCategories'
import { useEffect, useState } from 'react'

export const useSpecialization = (categories: any, tagIdList: any, field: string) => {
  const [specialization, setSpecialization] = useState<IFormCategories[]>([])

  useEffect(() => {
    if (!categories || !tagIdList) return
    const newSpecialization = categories.filter(
      (value: IFormCategories) => tagIdList.includes(value.id) && value.tag_group === field
    )

    if (JSON.stringify(newSpecialization) !== JSON.stringify(specialization)) {
      setSpecialization(newSpecialization)
    }
  }, [categories, tagIdList])

  return specialization
}
